export default "__VITE_ASSET__blCV9zjF__"